module.exports = __webpack_public_path__ + "static/media/graphic3@2x.a75bded5.png";